// Now imported from 4-one-of-one/_selectors
import { OUTLINE_WRAPPER_SELECTOR, SCRIPT_TEXT } from "../4-one-of-one/_selectors";

// Re-export for other files to use
export { SCRIPT_TEXT, OUTLINE_WRAPPER_SELECTOR };

export const STYLE_ACTIVE = ".pplr-choose-style .pplr-drop-item.active";

export const CURRENT_COLOR_SELECTOR =
	".pplr-color-select.pplr-outline .pplr-swatch-element.pplrColor.color_display_box.selected:not(.pplr_White)";

export const KNIT_BEANIE_TEXT = ".pplr-knit-beanie-text";
export const KNIT_BEANIE_ACTIVE = "._pplr_knit_beanies.active";
export const KNIT_BEANIE_INPUT = ".pplr-knit-beanie-text input";
export const KNIT_BEANIE_NOT_COLOR_OR_FONT =
	".pplr-knit-beanie-text:not(.pplr-color-select):not(.pplr-font-select)";

export const MICRO_BEANIE_INPUT = ".pplr-microbeanie-text input";
export const MICRO_BEANIE_NOT_COLOR_OR_FONT =
	".pplr-microbeanie-text:not(.pplr-color-select):not(.pplr-font-select)";

export const SCRIPT_TEXT_NOT_SELECT =
	".pplr-script-text:not(.pplr-color-select):not(.pplr-font-select) input";
export const SCRIPT_TEXT_OPTIONS = ".pplr-script-text .pplr-selecter-options";
export const SCRIPT_TEXT_OPTIONS_SPANS = ".pplr-script-text .pplr-selecter-options span";
export const SCRIPT_TEXT_FONT_SELECTOR = ".pplr-script-text.pplr-font-select";
export const SCRIPT_SWATCHES = `${SCRIPT_TEXT} .color_display_box`;
export const SCRIPT_SWATCHES_DEFAULT = `${SCRIPT_TEXT} .color_display_box.pplr_White`;
export const OUTLINE_WRAPPER_SELECTOR_MAIN =
	"div.pplr-wrapper.mcolor.pplr-color-select.pplr-outline .pplr-swatch-main";
export const OUTLINE_SWATCH_SELECTOR = ".pplr-outline .pplrgcolor .pplr-swatch-element";
export const OUTLINE_INPUT = ".pplr-outline input";
export const OUTLINE_REMOVE_BUTTON = `${OUTLINE_WRAPPER_SELECTOR} .remove-btn`;

export const SWATCH_THREADS = ".pplr-swatch-element.color_display_box";
export const SWATCH_THREADS_MINUS_OUTLINE = `.mcolor:not(.pplr-outline) ${SWATCH_THREADS}`;

export const SELECTED_HAT_COLOR = ".pplr-choose-hat-color .pplr-swatch-element.selected";
export const HAT_COLOR = ".pplr-choose-hat-color";
